import AuthAdminUserModel from '../../code/models/AuthAdminUserModel';
import AdminBidPackagesForm from './AdminBidPackagesForm';
import AdminBidPeriodsForm from './AdminBidPeriodsForm';
import AdminCreditRangeForm from './AdminCreditRangeForm';
import AdminEmailTemplates from "./AdminEmailTemplates";
import AdminMonthlyBilling from "./AdminMonthlyBilling";
import AdminOptionGroupsForm from './AdminOptionGroupsForm';
import AdminOptionsForm from './AdminOptionsForm';
import AdminPromotions from "./AdminPromotions";
import AdminSystemConfigurationForm from './AdminSystemConfigurationForm';
import AdminSystemEmailTemplates from "./AdminSystemEmailTemplates";
import AdminWaiveForm from './AdminWaivesForm';
import AdminSendBatchEmail from "./AdminSendBatchEmail";
import AdminUserManagement from "./AdminUserManagement";
import AdminCustomerBlocksForm from "./AdminCustomerBlocksForm";
import AdminDefaultAircraft from "./AdminDefaultAircraft";
import AdminDefaultAirport from "./AdminDefaultAirport";
import AdminDefaultRegion from "./AdminDefaultRegion";
import AdminQcForm from "./AdminQcForm";
import AdminAwardReportsForm from "./AdminAwardReportsForm";

import "../../css/adminmainform.css";
import AdminQCQuickNotesForm from "./AdminQCQuickNotesForm";
import AdminDefaultReportAirport from './AdminDefaultReportAirport';
import AdminNewUserEmailTemplates from "./AdminNewUserEmailTemplates";

const logoIcon = require('../../images/ccl-icon.png');

interface IAdminMainForm {
    adminUser: AuthAdminUserModel;
    currentPage: string;
}

export default function AdminMainForm({ adminUser, currentPage }: IAdminMainForm) {

    function canDefaultDisplay() {
        const currentPages: string[] = ["sys-config", "bid-periods", "bid-option-groups", "bid-options",
            "bid-waives", "bid-credit-range", "bid-packages", "bill-monthly", "bill-promos", "email-templates",
            "adm-templates", "email-awards", "email-customers", "adm-user-mgt", "adm-blocks", "data-aircraft",
            "data-airports", "data-regions", "data-report-airports", "qc-customers", "qc-quicknotes",
            "activation-emails"];

        return currentPages.indexOf(currentPage) === -1;
    }

    return (
        <main className='main-content'>
            {currentPage === "sys-config" && <AdminSystemConfigurationForm adminUser={adminUser} />}
            {currentPage === "bid-periods" && <AdminBidPeriodsForm adminUser={adminUser} />}
            {currentPage === "bid-option-groups" && <AdminOptionGroupsForm adminUser={adminUser} />}
            {currentPage === "bid-options" && <AdminOptionsForm adminUser={adminUser} />}
            {currentPage === "bid-waives" && <AdminWaiveForm adminUser={adminUser} />}
            {currentPage === "bid-credit-range" && <AdminCreditRangeForm adminUser={adminUser} />}
            {currentPage === "bid-packages" && <AdminBidPackagesForm adminUser={adminUser} />}
            {currentPage === "bill-monthly" && <AdminMonthlyBilling adminUser={adminUser} />}
            {currentPage === "bill-promos" && <AdminPromotions adminUser={adminUser} />}
            {currentPage === "email-templates" && <AdminEmailTemplates />}
            {currentPage === "adm-templates" && <AdminSystemEmailTemplates />}
            {currentPage === "activation-emails" && <AdminNewUserEmailTemplates />}
            {currentPage === "email-awards" && <AdminAwardReportsForm />}
            {currentPage === "email-customers" && <AdminSendBatchEmail adminUser={adminUser} />}
            {currentPage === "adm-user-mgt" && <AdminUserManagement />}
            {currentPage === "adm-blocks" && <AdminCustomerBlocksForm />}
            {currentPage === "data-aircraft" && <AdminDefaultAircraft />}
            {currentPage === "data-airports" && <AdminDefaultAirport />}
            {currentPage === "data-regions" && <AdminDefaultRegion />}
            {currentPage === "data-report-airports" && <AdminDefaultReportAirport />}
            {currentPage === "qc-customers" && <AdminQcForm adminUser={adminUser} />}
            {currentPage === "qc-quicknotes" && <AdminQCQuickNotesForm />}

            {canDefaultDisplay() && <div className="admin-main-form-logo">
                <div><h3>{currentPage}</h3></div>
                <img src={logoIcon} alt="CCL Software" />
            </div>}
        </main>
    )
}
